import * as ReactService from "@intech/react-service";
import { SimuladorRendaMensalDatas } from "../entidades/SimuladorRendaMensalDatas";

class SimuladorRendaMensal extends ReactService.BaseService {
  constructor() {
    super("SimuladorRendaMensal");
  }

  BuscarDatas = () =>
    this.CreateRequest<SimuladorRendaMensalDatas>(ReactService.RequestType.GET, `BuscarDatas`);

  BuscarDatasResultado = (dataInicioRMV: string, dataReferencia: string, dataAporte: string) =>
    this.CreateRequest<SimuladorRendaMensalDatas>(ReactService.RequestType.GET, `BuscarDatasResultado/${dataInicioRMV}/${dataReferencia}/${dataAporte}`);

  BuscarFatorAtuarialInterpolado = () =>
    this.CreateRequest<number>(ReactService.RequestType.GET, `BuscarFatorAtuarialInterpolado`);

  BuscarFatorAtuarialInterpoladoPorData = (data: string) =>
    this.CreateRequest<number>(ReactService.RequestType.GET, `BuscarFatorAtuarialInterpoladoPorData/${data}`);

  BuscarIndice = () =>
    this.CreateRequest<number>(ReactService.RequestType.GET, `BuscarIndice`);

  ValidarDataInicioRMV = (dataRMV: string) =>
    this.CreateRequest<string>(ReactService.RequestType.GET, `ValidarDataInicioRMV/${dataRMV}`);

  ValidarDataAporte = (dataAporte: string, dataRMV: string) =>
    this.CreateRequest<string>(ReactService.RequestType.GET, `ValidarDataAporte/${dataAporte}/${dataRMV}`);

}

export const SimuladorRendaMensalService = new SimuladorRendaMensal();
